import * as React from "react";
import {
  Box,
  IconButton,
  InputAdornment,
  Typography,
} from "@mui/material";
import { FormProvider } from "react-hook-form";
import { Visibility, VisibilityOff } from "@mui/icons-material";

import ForgotPasswordMessage from "../../../utils/Enums";
import GraphicElements from "../../../styles/svg/graphic_elements.svg";
import { useResponsive } from "../../../hooks/useResponsive";
import mobileBg from "../../../styles/svg/login_bg_mobile.svg";
import { useAssets } from "../../../reactQuery/domainAssets";
import { getAPIBaseUrl } from "../../../utils/constants";
import TenantSiteName from "../../../components/TenantSiteName";
import { CustomButton } from "../../../components/Button/Button";
import { RFHTextField } from "../../../components/RFH";
import { PassWordRequirement } from "../../../components/ChangePassword";
import { useResetPasswordForm } from "../hooks/useResetPasswordForm";

function ResetPasswordForm({ uuid, email = "" }) {
  const { logo } = useAssets();
  const apiUrl = getAPIBaseUrl();
  const isMobile = useResponsive("down", "md");
  const {
    methods,
    showPassword,
    isLoading,
    allRequirementsMet,
    submit,
    togglePasswordVisibility,
    handleFormError,
  } = useResetPasswordForm({ uuid, email });
  const password = methods.watch("password") || "";
  const { handleSubmit } = methods;

  return (
    <Box
      component="main"
      className="forgotpassword-box"
      sx={{
        backgroundImage: `url(${isMobile ? mobileBg : GraphicElements})`,
      }}
      disableGutters={true}
    >
      <Box className="forgotpassword-innerBox">
        {logo ? (
          <img
            src={`${apiUrl}/${logo}`}
            alt="not found"
            width={isMobile ? 251 : ""}
            className="login_logo"
          />
        ) : (
          <TenantSiteName />
        )}
        <FormProvider {...methods}>
          <Box
            component="form"
            onSubmit={handleSubmit(submit, handleFormError)}
            noValidate
            className="submitForm-box"
          >
            <Typography
              className="text-center black-primary-color mb-4 weight-700"
              component={"h1"}
              variant="h5"
            >
              {ForgotPasswordMessage.CREATE_NEW_PASSWORD}
            </Typography>
            <Typography
              className="text-center forgot-password-para mb-2"
              component={"h1"}
              variant="h5"
            >
              {ForgotPasswordMessage.CREATE_NEW_PASSWORD_MESSAGE}
            </Typography>

            <PassWordRequirement password={password} className="reset-password-requirement-list" />

              {/* Visible username/email field so browser password managers can associate the new password */}
              <RFHTextField
              margin="normal"
              fullWidth
              name="email"
              label="Email"
              id="email"
              autoComplete="email"
              defaultPadding={false}
              value={email}
              readOnly
              style={{ display: "none" }}
            />

            <RFHTextField
              margin="normal"
              required
              fullWidth
              name="password"
              label="New Password"
              type={showPassword.password ? "text" : "password"}
              id="password"
              autoComplete="new-password"
              defaultPadding={false}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      onClick={() => togglePasswordVisibility("password")}
                      edge="end"
                      aria-label="toggle password visibility"
                    >
                      {showPassword.password ? <Visibility /> : <VisibilityOff />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
              inputProps={{
                className: "password-manager-hidden",
                autoCapitalize: "none",
                autoCorrect: "off",
                spellCheck: false,
                "data-lpignore": "true",
                "data-1p-ignore": "true",
              }}
            />

            <RFHTextField
              margin="normal"
              required
              fullWidth
              name="confirmpassword"
              label="Confirm Password"
              type={showPassword.confirmPassword ? "text" : "password"}
              id="confirmpassword"
              autoComplete="new-password"
              defaultPadding={false}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      onClick={() =>
                        togglePasswordVisibility("confirmPassword")
                      }
                      edge="end"
                      aria-label="toggle password visibility"
                    >
                      {showPassword.confirmPassword ? (
                        <Visibility />
                      ) : (
                        <VisibilityOff />
                      )}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
              inputProps={{
                className: "password-manager-hidden",
                autoCapitalize: "none",
                autoCorrect: "off",
                spellCheck: false,
                "data-lpignore": "true",
                "data-1p-ignore": "true",
              }}
            />

            <CustomButton
              type="submit"
              fullWidth
              variant="contained"
              className="btn-blue capitalize submit-button"
              disabled={isLoading || !allRequirementsMet}>
              Reset Password
            </CustomButton>
          </Box>
        </FormProvider>
      </Box>
    </Box>
  );
}

export default ResetPasswordForm;
